import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

export const DEFAULT_ERROR_HEADING = "That page isn't here. Sorry about that!";
export const DEFAULT_ERROR_MESSAGE =
  "It looks like the URL is broken or the page has been moved. Try hitting your back button or navigating to another page.";

@Component({
    selector: "app-error-page",
    templateUrl: "./error-page.component.html",
    styleUrls: ["./error-page.component.scss"],
    standalone: false
})
export class ErrorPageComponent implements OnInit {
  heading: string;
  errorMessage: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.heading = this.route.snapshot.data["heading"] ?? DEFAULT_ERROR_HEADING;
    this.errorMessage = this.route.snapshot.data["message"] ?? DEFAULT_ERROR_MESSAGE;
  }

  goBack(): void {
    if (window.history.length > 1) {
      window.history.back();
      return;
    }

    this.router.navigate(["/manage-orders"]);
  }
}
